import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Profile page - displays authenticated user's profile (Auth0).
 */
const ProfilePage = () => {
    const { user } = useAuth0();

    if (!user) {
        return (
            <div className="container mt-4">
                <p>No profile data available.</p>
            </div>
        );
    }

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="card shadow-sm">
                        <div className="card-body p-4">
                            <h4 className="card-title mb-4">Profile</h4>
                            <div className="d-flex align-items-center mb-4">
                                {user.picture && (
                                    <img
                                        src={user.picture}
                                        alt={user.name || 'Profile'}
                                        className="rounded-circle mr-3"
                                        style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                    />
                                )}
                                <div>
                                    <h5 className="mb-1">{user.name || 'No name'}</h5>
                                    <p className="text-muted mb-0">{user.email || ''}</p>
                                </div>
                            </div>
                            <dl className="row mb-0">
                                {user.email_verified !== undefined && (
                                    <>
                                        <dt className="col-sm-4">Email verified</dt>
                                        <dd className="col-sm-8">{user.email_verified ? 'Yes' : 'No'}</dd>
                                    </>
                                )}
                                {user.sub && (
                                    <>
                                        <dt className="col-sm-4">User ID</dt>
                                        <dd className="col-sm-8 text-muted small">{user.sub}</dd>
                                    </>
                                )}
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
